<template>
  <Layout>
    <b-overlay :show="isLoading" rounded="sm">
    <div class="card" style="min-height: 100vh;">
      <div class="card-body" >
        <PageHeader :title="title" :items="items" />
        <button class="btn btn-info mb-3" v-on:click="procesar()">Procesar en lote</button>
        <div class="form-row">
          <div class="form-group col-md-7">
            <label>Filtro de tipo</label>
            <v-select :options="expedientes_tipos"
                      label="descripcion"
                      v-model="filtro.expediente_tipo_id"
                      :reduce="descripcion=>descripcion.id"
                      @input="loadItems()"
            />
          </div>
          <div class="form-group col-md-5">
            <label>Filtro de escuela</label>
            <v-select
                    :options="carreras_profesionales"
                    label="carrera"
                    :reduce="carrera=>carrera.codigo"
                    v-model="filtro.codigo_carrera"
                    @input="loadItems()"
            />
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-8">
            <label>Busqueda por nombre</label>
            <input type="text" class="form-control" v-model="filtro.termino_de_busqueda"  ><!--termino_de_busqueda-->
          </div>
          <div class="form-group col-md-4">
            <button class="btn btn-info mt-4 mr-2" v-on:click="loadItems">Buscar</button>
            <button class="btn btn-info mt-4" v-on:click="limpiarBusqueda">Limpiar</button>
          </div>


        </div>


        <table class="table  font-size-13 fixtable">
          <thead  class="table-info">
            <!--<th>ID</th>-->
            <th>Nº Exp.</th>
            <th>Tipo trámite</th>
            <th>Nombre / Denominación</th>
            <th>Código</th>
            <th>Dias de trámite</th>
            <th>E.P.</th>

            <th >Archivos</th>
            <th width="25%" >Acciones</th>
          </thead>
          <tbody v-for="(data,index) in rows_filtered"  v-bind:key="index">
            <tr>
              <!--<td>{{data.id}}</td>-->
              <td>{{data.numero_referencia}}</td>
              <td><small><strong>Trámite:</strong></small> <a href="javascript:void(0);" v-on:click="mostrarModal(data.id)">{{data.tipo_expediente}}</a> </td>
              <td> <a href="javascript:void(0);" v-on:click="mostrarEstudiante(data)">{{data.denominacion}}</a> </td>
              <td><small><strong>Código: </strong></small>{{ data.codigo}}</td>
              <td> <small><strong>Dias: </strong></small> {{ data.dias }}</td>
              <td><small><strong>E.P: </strong></small>{{data.carrera}}</td>
              <td><small><strong>Archivos: </strong></small>
                <div  v-for="(data, index) in data.archivos"
                        v-bind:key="index"
                      style="float:left"
                >


                  <a :href="server + '/storage/' + data.nombre" target="_blank"  v-b-tooltip.top="data.nombre_original" >
                    <i
                            class="mdi mdi-cloud-download mr-1"
                            style="font-size: 20px;color: #000000"
                    /></a>
                </div>

              </td>
              <td>
                <button class="btn btn-info mr-1" v-on:click="procesarEsteRegistro(index)">
                  Procesar
                </button>
                <button class="btn btn-warning" v-on:click="mostrarAcciones(data.id,data.expediente_tipo_id,data.expediente_derivacion_id)">
                  Acciones
                </button>
              </td>

            </tr>
            <tr>
              <td colspan="8" class="pl-2 pt-1 pb-0">
                <div class="form-row">
                  <div class="form-group col-md-4" style="height: 12px">
                    <label>Derivar</label>
                    <v-select
                            class="v-select"
                            :options="oficinas"
                            v-model="data.oficina_id"
                            aria-placeholder="Seleccione"
                            label="descripcion"
                            :reduce="oficina=>oficina.id"
                            style="position: relative"
                            required>
                    </v-select>
                  </div>
                  <div class="form-group col-md-4">
                    <label>Adjuntar Archivos</label>
                    <div class="input-group">
                      <!--<b-form-file
                              placeholder="Sel. Archivo"
                              v-model="data.archivos_derivacion"
                              class="small"
                              multiple/>-->
                      <b-form-file
                              placeholder="Sel. Archivo"
                              v-model="archivoActual"
                              class="small"
                              @input="agregarArchivo(index)"
                              multiple/>
                    </div>
                    <small  class="form-text font-size-11 " v-show=" typeof (data.archivos_derivacion) !=='undefined' ">
                      <table class="table table-sm">
                        <thead>
                          <th>Archivo</th>
                          <th>Tamaño</th>
                          <th>Op</th>
                        </thead>
                        <tbody>
                          <tr  v-for="(data2,index2) in data.archivos_derivacion"  v-bind:key="index2">
                            <td>
                              {{data2.name}}
                            </td>
                            <td>
                              {{(data2.size / (1024*1024)).toFixed(2)}} Mb
                            </td>
                            <td>
                              <a  class="btn btn-sm btn-outline-danger" v-on:click="borrar(index,index2)">
                                <i class="fa fa-trash "></i>
                              </a>


                            </td>
                          </tr>


                        </tbody>
                      </table>

                    </small>
                  </div>
                  <div class="form-group col-md-4">
                    <label>Observaciones</label>
                    <textarea class="form-control" v-model="data.observacion"/>
                  </div>
                </div>

              </td>

            </tr>
            <tr>
              <td colspan="8" style="border-top: 2px solid rgba(32,138,153,0.69) !important;">

              </td>
            </tr>

          </tbody>

        </table>
        <b-modal
                id="modalExpediente"
                scrollable
                title="Expediente"
                title-class="font-18"
                size="xl"
        >
          <ExpedienteInfo :modal="modal" />
        </b-modal>
        <b-modal
                id="modalAcciones"
                scrollable
                title="Expediente acciones"
                title-class="font-18"
                size="xl"
                hide-footer
        >
          <ExpedienteAcciones
                  :data="modal"
                  :templates="templates"
                  :oficinas="oficinas"
                  v-on:accioncompleta="ocultarModal"
          />

        </b-modal>

        <b-modal
                id="modalEstudiante"
                scrollable
                title="Estudiante"
                title-class="font-18"
                size="lg"
        >
          <EstudianteInfo :data="estudiante" />
        </b-modal>
      </div>
    </div>
    </b-overlay>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import ExpedienteInfo from '@/components/expediente-info';
import EstudianteInfo from '@/components/estudiante-info';
import ExpedienteAcciones from '@/components/expediente-acciones';
import constantes from "../../../config/Constantes";


/**
 * Dashboard Component
 */
export default {

  page: {
    title: "Expedientes",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader,
    ExpedienteInfo,
    ExpedienteAcciones,
    EstudianteInfo,


  },
  data() {
    return {

      oficinas:[],
      title: "Expedientes",
      expedientes_tipos:[],
      items: [
        {
          text: "Expedientes",
          href: "/"
        },
        {
          text: "",
          active: true
        }
      ],
      archivoActual:null,
      rows:[

      ],
      isLoading: false,
      server:process.env.VUE_APP_BACKEND,
      modal:{},
      templates:[],
      estudiante:{},
      filtro:{
        expediente_tipo_id:null,
        codigo_carrera:null,
        termino_de_busqueda:""
      },
      carreras_profesionales:[],
      serverParams: {

      },
      termino_de_busqueda:"",
      rows_filtered:[],
      rows_sin_filtro:[]
    };
  },

  methods: {

    limpiarBusqueda(){
      this.filtro.termino_de_busqueda="";
      this.loadItems();
    },

    borrar(index,index2){
      //this.removeField(data,index2)
      this.$delete(this.rows_filtered[index].archivos_derivacion,index2);
      this.$forceUpdate();
    },
    removeField(v_array,index) {
      //this.$delete(v_array,index);
      v_array.splice(index, 1);
    },
    agregarArchivo(index){
      console.log(this.archivoActual);
      if(typeof (this.rows_filtered[index].archivos_derivacion) ==="undefined")
      {
        this.rows_filtered[index].archivos_derivacion=[];
      }
      this.archivoActual.forEach((item)=>{
        this.rows_filtered[index].archivos_derivacion.push(item);
      })

      //      console.log(index);
    },
    mostrarEstudiante(row){
      this.isLoading=true;
      this.estudiante={};
      this.axios.get(
              process.env.VUE_APP_BACKEND + "/api/estudiantes/buscar", {
                params: {
                  codigo:row.codigo,
                  codigo_carrera:row.codigo_carrera
                }
              }
            )
              .then((response)=>{
                this.estudiante=response.data;
                this.$bvModal.show("modalEstudiante");
              })
              .finally(()=>{
                this.isLoading=false;
              })
    },
    procesarEsteRegistro(index){
      let oficina_seleccionada, archivo_adjunto,observacion;
      if(this.rows_filtered[index].oficina_id===undefined)
      {
        this.$swal('Cuidado','Seleccione una oficina','warning');
        return;
      }
      //////////
      if(this.rows_filtered[index].oficina_id===-1)
      {
        oficina_seleccionada="Finalizar tramite";
      }
      else
      {
        this.oficinas.forEach((item)=>{
          if(item.id===this.rows_filtered[index].oficina_id){
            oficina_seleccionada=item.descripcion;
          }
        });
      }

      //////////
      archivo_adjunto="No";
      if(this.rows_filtered[index].archivos_derivacion !==undefined)
      {
        archivo_adjunto="";
        this.rows_filtered[index].archivos_derivacion.forEach((item)=>{
          archivo_adjunto += item.name + ", ";
        })
      }
      observacion="-";
      if(this.rows_filtered[index].observacion !==undefined)
      {
        observacion=this.rows_filtered[index].observacion;
      }
      this.$swal
              .fire({
                title: "¿Esta seguro de procesar el expediente?",
                html: "<strong>Nombres:</strong> "+this.rows_filtered[index].denominacion +"<br>" +
                      "<strong>Oficina seleccionada:</strong> "+oficina_seleccionada  +"<br>" +
                      "<strong>Archivo adjunto:</strong> "+archivo_adjunto  +"<br>" +
                      "<strong>Observación:</strong> "+observacion  +"<br>" ,
                icon: "warning",

                showCancelButton: true,
                confirmButtonColor: "#4049D8",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Si, procesar.",
                showLoaderOnConfirm: true
              })
              .then(result => {
                if (result.value) {
                  let row_process=[];
                  row_process.push(this.rows_filtered[index]);
                  this.procesarRegistros(row_process);
                }
              });



    },
    procesar(){
      let valid=true;
      /// CHECK DATA
      let rows_process=[];
      this.rows_filtered.forEach((item)=>{
        if(item.archivos_derivacion !==undefined){// EN CASO DE QUE HAYA ARCHIVOS
          if(item.oficina_id ===undefined){
            this.$swal('Cuidado','Tiene archivos adjuntos, pero no selecciono una oficina','warning');
            valid=false;
            return;
          }
          else {
            rows_process.push(item);
          }
        }
        else {//EN CASO DE QUE NO
          if(item.oficina_id !==undefined){
            rows_process.push(item);
          }
        }
      });
      if(valid===false){
        return
      }
      this.procesarRegistros(rows_process);
      //////////////

    },
    procesarRegistros(rows_process){
      let formData = new FormData();
      this.isLoading=true;
      this.model_save = Object.assign({}, rows_process);
      Object.keys(this.model_save).forEach(key => {
        const data = JSON.stringify( this.model_save[key]);
        formData.append(key,data);
        // ...
      });
      this.rows_filtered.forEach((item)=>{
        if(item.archivos_derivacion !==undefined)
        {
          item.archivos_derivacion.forEach((item2)=>{
            formData.append('file['+item.id+'][]',item2);
          })
        }
      });
      ////////////////////
      this.axios
              .post(
                      process.env.VUE_APP_BACKEND + "/api/expedientes/procesar",
                      formData,
                      {
                        headers: {
                          "Content-Type": "multipart/form-data"
                        },
                      }
              )
              .then(response => {
                if (response.data.success) {
                  this.$swal("OK", "Se recepciono los expedientes", "success");
                }
                else

                {
                  this.$swal("error", "Hubo un error al procesar su solicitud, contacte con soporte.", "error");
                }

              })
              .catch(() => {
                this.$swal("error", "Error", "error");
              })
              .finally(() => {
                this.isLoading = false;
                this.loadItems();
              });

    },
    decimal(value) {
      if (value === null) {
        return "-";
      } else {
        return parseFloat(value).toFixed(2);
      }
    },


    // load items is what brings back the rows from server
    loadItems() {
      this.isLoading = true;
      this.serverParams.filtro=this.filtro;
      this.axios
        .get(process.env.VUE_APP_BACKEND + "/api/expedientes/tabla-tramite", {
          params: this.serverParams
        })
        .then(response => {
          //console.log(response.data.data);
          this.totalRecords = response.data.total_records;
          this.rows_filtered = response.data.data;
          //this.rows_sin_filtro=response.data.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          //console.log(error);
        });
    },

    async mostrarAcciones(expediente_id,expediente_tipo_id,expediente_derivacion_id){
      let derivacion;
      this.isLoading=true;
      this.modal= await  this.axios.get( process.env.VUE_APP_BACKEND +'/api/expedientes/'+expediente_id)
              .then((response)=>{
                return response.data;
              });
      this.templates= await  this.axios.get( process.env.VUE_APP_BACKEND +'/api/documento-tipo/templates/'+expediente_tipo_id+'/'+expediente_id)
              .then((response)=>{
                return response.data;
              });
      derivacion=await  this.axios.get( process.env.VUE_APP_BACKEND +'/api/expedientes/derivaciones/'+expediente_derivacion_id)
              .then((response)=>{
                return response.data;
              });
      this.modal.expediente_derivacion_id=expediente_derivacion_id;
      this.modal.derivacion=derivacion;
      this.isLoading=false;
      this.$bvModal.show("modalAcciones");

    },
    mostrarModal(expediente_id){
      this.isLoading=true;
      this.axios.get( process.env.VUE_APP_BACKEND +'/api/expedientes/'+expediente_id)
              .then((response)=>{
                this.modal=response.data;
                this.$bvModal.show("modalExpediente");
              }).finally(()=>this.isLoading=false);

    },
    ocultarModal()
    {
      this.$bvModal.hide("modalAcciones");
      this.loadItems();
    },
    /* eslint-enable */
  },

  mounted() {

    this.isLoading=true;
    this.axios.get(process.env.VUE_APP_BACKEND + '/api/oficinas')
            .then(response=>{
              let finalizar;
              finalizar={
                "id":-1,
                "descripcion": "(FINALIZAR TRAMITE)"
              };
              this.oficinas=response.data;
              this.oficinas.push(finalizar);
            });
    this.axios.get(process.env.VUE_APP_BACKEND+'/api/expediente-tipo')
            .then((response)=>
            {
              this.expedientes_tipos=response.data;
              this.expedientes_tipos.unshift({
                id:0,
                descripcion:"(Todos)"
              });
              this.carreras_profesionales =JSON.parse(JSON.stringify(constantes.carreras_profesionales_habilitadas));// {... };
              this.carreras_profesionales.unshift({'codigo':0,'carrera':'(Todos)'});
              this.filtro.expediente_tipo_id=0;
              this.filtro.codigo_carrera=0;
              this.loadItems();
            })
            .finally(()=>{

            })
            .catch(()=>{

            })

  }
};
</script>

<style>
.fixtable {
  color: #000000 !important;
}
.v-select .dropdown-menu {
  display:block;
}
</style>
